import { ExclamationCircleOutlined } from '@ant-design/icons'
import { BBDTag } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import type * as React from 'react'

interface WarningTagProps {
  errorCount?: number
  warningCount?: number
  tooltipErrorPrefix?: string
  tooltipWarningPrefix?: string
}

/**
 * A reusable warning tag component that displays error or warning indicators
 */
export function WarningTag({
  errorCount = 0,
  warningCount = 0,
  tooltipErrorPrefix = 'orders',
  tooltipWarningPrefix = 'orders',
}: WarningTagProps) {
  if (errorCount > 0) {
    return (
      <Tooltip title={`${errorCount} ${tooltipErrorPrefix} require attention and are past their invoice date`}>
        <BBDTag style={{ width: 'fit-content' }} error>
          <ExclamationCircleOutlined /> {errorCount}
        </BBDTag>
      </Tooltip>
    )
  }

  if (warningCount > 0) {
    return (
      <Tooltip title={`${warningCount} ${tooltipWarningPrefix} need attention to be invoiced`}>
        <BBDTag style={{ width: 'fit-content' }} warning>
          <ExclamationCircleOutlined /> {warningCount}
        </BBDTag>
      </Tooltip>
    )
  }

  return null
}
